var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNiger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 512,
    viewBox: "0 0 513 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_7238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3903 144.696C10.1163 178.352 0.988281 216.109 0.988281 256C0.988281 295.891 10.1163 333.648 26.3903 367.304L256.988 389.565L487.586 367.304C503.86 333.648 512.988 295.891 512.988 256C512.988 216.109 503.86 178.352 487.586 144.696L256.988 122.435L26.3903 144.696Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3992 367.304C67.8052 452.935 155.494 512 256.988 512C358.482 512 446.171 452.935 487.577 367.304H26.3992Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3992 144.696H487.577C446.171 59.065 358.481 0 256.988 0C155.495 0 67.8052 59.065 26.3992 144.696Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.988 345.043C306.165 345.043 346.031 305.177 346.031 256C346.031 206.823 306.165 166.957 256.988 166.957C207.811 166.957 167.945 206.823 167.945 256C167.945 305.177 207.811 345.043 256.988 345.043Z",
    fill: "#FF9811"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_7238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white",
    transform: "translate(0.988281)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNiger);
export default __webpack_public_path__ + "static/media/niger.c365b046b56fea2d8b3617211e3deb03.svg";
export { ForwardRef as ReactComponent };